import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'
import { LocatorState } from './types'

export const getters: GetterTree<LocatorState, RootState> = {
  search: ({ search }) => search,
}
